import { useEffect, useState } from 'react';
import { useActiveCompanyStore } from 'stores/activeCompanyStore';
import {
  readQuickLinkRecentPaths,
  subscribeQuickLinksRecent,
} from 'utils/quickLinksRecentStorage';

/** Latest ordered list of recent quick-link pathnames (newest first), or [] if none / not ready. */
export function useQuickLinkRecentPaths(): string[] {
  const activeCompanyId = useActiveCompanyStore((s) => s.activeCompanyId);
  const isInitialized = useActiveCompanyStore((s) => s.isInitialized);
  const [tick, setTick] = useState(0);
  const [paths, setPaths] = useState<string[]>([]);

  useEffect(() => subscribeQuickLinksRecent(() => setTick((t) => t + 1)), []);

  useEffect(() => {
    if (!isInitialized || !activeCompanyId) {
      setPaths([]);
      return;
    }
    setPaths(readQuickLinkRecentPaths(activeCompanyId));
  }, [activeCompanyId, isInitialized, tick]);

  return paths;
}
